<template>
    <div>
        <div class="vx-row mb-base">
            <vx-card class="w-full ml-4 mr-4">
                <div class="vx-row ml-1">
                    <span class="vx-col">Data de fechamento:</span>
                </div>  
                <div class="vx-row ml-1">
                    <div class="vx-col sm:w-full md:w-4/12 lg:w-3/12 xl:w-3/12 w-full mb-4 ">
                        <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="date"></datepicker>
                    </div>
                    <div class="vx-col sm:w-full md:w-2/12 lg:w-2/12 xl:w-2/12 w-full mb-4">
                        <vs-button  type="relief" class="w-full"  @click="getClosingData()"> <a-icon type="filter" /> Filtrar</vs-button>
                    </div>
                    <div class="vx-col sm:w-full md:w-2/12 lg:w-2/12 xl:w-2/12 w-full" v-if="payments.length">
                        <vs-button id="print" type="relief" class="w-full vs-con-loading__container"  @click="modalPrint.visible = true" > <a-icon type="printer" /> Imprimir</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>

        <a-modal
            :z-index="999999"
            title="Selecione o modo de impressão"
            :width="400"
            v-model="modalPrint.visible"
            :visible="modalPrint.visible"
            :footer="null"
            >
            <div class="flex w-full">
                <vs-button class="mr-4 w-full" @click="printClosingData()"> Simples </vs-button>
                <vs-button class="w-full" @click="printClosingData(true)"> Detalhado </vs-button>
            </div>
        </a-modal>
        
        <div class="vx-row" v-if="payments.length == 0">
            <h4 class="w-full text-center"> Não há dados </h4>
        </div>
        <div class="vx-row" v-if="payments.length > 0">
            <statistics-bar-card-payment  class="vx-col sm:w-full md:w-6/12 lg:w-4/12 xl:w-4/12 w-full" :dataPayments="payments" :totalOrders="totalOrders" />
            <statistics-table-card-products  class="vx-col sm:w-full md:w-6/12 lg:w-4/12 xl:w-4/12 w-full" :data="products" />
            <statistics-line-card-users class="vx-col sm:w-full md:w-6/12 lg:w-4/12 xl:w-4/12 w-full" :users="users" />
            <statistics-bar-card-taxes class="vx-col sm:w-full md:w-6/12 lg:w-4/12 xl:w-4/12 w-full" :dataTaxes="taxes" />
        </div>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import StatisticsBarCardPayment from '@/components/statistics-cards/closing/StatisticsBarCardPayment'
    import StatisticsTableCardProducts from '@/components/statistics-cards/closing/StatisticsTableCardProducts'
    import StatisticsLineCardUsers from '@/components/statistics-cards/closing/StatisticsLineCardUsers'
    import StatisticsBarCardTaxes from '@/components/statistics-cards/closing/StatisticsBarCardTaxes'
    import Datepicker from 'vuejs-datepicker';
    import * as lang from 'vuejs-datepicker/src/locale';

    const db = firebase.firestore()

    export default {
        components : {
            StatisticsBarCardPayment,
            StatisticsTableCardProducts,
            StatisticsLineCardUsers,
            StatisticsBarCardTaxes,
            Datepicker
        },

        data () {
            return {
                modalPrint : {
                    visible : false
                },
                oldDate : '',
                date: new Date(),
                languages: lang,
                highlightedFn : {
                    customPredictor(date) {
                        let today = new Date()
                        if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
                            return true;
                        }
                    }
                },
                datePeriod : {
                    from : '',
                    to : ''
                },
                totalOrders : 0,
                payments : [],
                products : [],
                users : [],
                taxes : [],
                closingId : ''
            }
        },

        methods : {
            async printClosingData (detailed = false) {
                try {
                    const companyId = this.$store.getters.getCompanyID;
                    this.$vs.loading()
                    await db.collection(`/company/${companyId}/counters/closing/daily`)
                            .doc(this.closingId)
                            .update({ printAgain : new Date(), detailedPrint : detailed }, { merge : true })
                    this.modalPrint.visible = false
                } catch (err) {
                    this.$error({
                        zIndex : 999999,
                        title: 'Erro',
                        content: `Erro ao imprimir: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            async getClosingData () {
                this.clearPaymentData()

                try{
                    this.$vs.loading()
                    let rangeDate = this.getRangeDate()
                    let companyId = this.$store.getters.getCompanyID;
                    let ref = firebase.firestore().collection(`/company/${companyId}/counters/closing/daily/`)
                    let closingCounters = await ref
                                                .where('date', '>=', rangeDate.from)
                                                .where('date', '<=', rangeDate.to)
                                                .get()

                    closingCounters.forEach(closing => {
                        this.closingId = closing.id
                        let data = closing.data()

                        if(closing.id == this.$options.filters.moment(this.date, 'YYYY-MM-DD')) {
                            if(data.payments)
                                Object.entries(data.payments).forEach(payment => {
                                    this.payments.push(payment[1])
                                })

                            if(data.products.product){
                                Object.entries(data.products.product).forEach(product => {
                                    this.products.push(product[1])
                                    this.totalOrders += product[1].quantity
                                })
                            }

                            if(data.taxes) {
                                Object.entries(data.taxes).forEach(tax => {
                                    this.taxes.push({
                                        description : tax[1].description,
                                        type : tax[0],
                                        value : tax[1].value
                                    })
                                })
                            }
                        }
                        
                        let tempArr = []
                        if(data.hasOwnProperty('customers'))
                            Object.entries(data.customers).forEach(customer => {
                                let date = new firebase.firestore.Timestamp(data.date.seconds, data.date.nanoseconds).toDate();
                                tempArr.push({...customer[1], ...{date: this.$options.filters.moment(date, 'YYYY-MM-DD')}})
                            })
                        this.users = [...this.users, ...tempArr]
                    })

                    this.oldDate = this.date
                } catch (err) {
                    this.$error({
                        zIndex : 999999,
                        title: 'Erro',
                        content: `Erro ao tentar filtrar fechamento: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
                
            },

            getRangeDate () {
                let fromDate = new Date(this.date);
                fromDate.setDate(fromDate.getDate()-7)
                fromDate.setHours(0)
                fromDate.setMinutes(0)
                fromDate.setSeconds(0)

                let toDate = new Date(this.date)
                toDate.setHours(23)
                toDate.setMinutes(59)
                toDate.setSeconds(59)

                return { from: fromDate, to: toDate }
            },

            clearPaymentData () {
                this.totalOrders = 0
                this.payments = []
                this.products = []  
                this.users    = []
                this.taxes    = []
            }
        }
    }
</script>